import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!sessionStorage.getItem("token");
  const location = useLocation();

  return isAuthenticated ? (
    children
  ) : (
    <Navigate
      to="/authentication/sign-in"
      state={{ from: location }}
      replace
    />
  );
};

export default PrivateRoute;
